module.exports = __webpack_public_path__ + "images/apple-touch-icon-152x152-a7220450e821254ab6cdb244c6e673f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicons/apple-touch-icon-152x152.png
// module id = ./src/images/favicons/apple-touch-icon-152x152.png
// module chunks = 1